import { render } from "./PCBanner.vue?vue&type=template&id=42f0c5e0&scoped=true"
import script from "./PCBanner.vue?vue&type=script&lang=js"
export * from "./PCBanner.vue?vue&type=script&lang=js"

import "./PCBanner.vue?vue&type=style&index=0&id=42f0c5e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f0c5e0"]])

export default __exports__